import React, { useState, useContext } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { TextField, Autocomplete } from "@mui/material";
import { SubActionContext } from "../../data/action/SubActionContext";
import { useValidations } from "../../data/ValidationContext"; 

function ActionAddModal({ show, handleClose, onSubmit }) {

  // State
  const [name, setName] = useState("");
  const [selectedSubActions, setSelectedSubActions] = useState([]);

  // Context
  const { subActions } = useContext(SubActionContext);
  const { vs_action } = useValidations(); 

  // Initial Formik Values
  const initialValues = {
    name: "",
    selectedSubActions: [],
  };

  // HTML / JSX
  
  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      <Formik
        initialValues={initialValues}
        validationSchema={vs_action} 
        onSubmit={(values, { resetForm }) => {
          // Form submit
          onSubmit({
            name: values.name,
            subActions: values.selectedSubActions,
          });
          resetForm();
          handleClose();
        }}
      >
        {({ values, setFieldValue, touched, errors }) => (
          <Form>
            {/* Modal Header */}
            <Modal.Header closeButton>
              <Modal.Title>Aksiyon Ekle</Modal.Title>
            </Modal.Header>

            {/* Modal Body */}
            <Modal.Body>
              {/* Ana aksiyon adı */}
              <Field
                as={TextField}
                name="name"
                label="Aksiyon Adı"
                variant="outlined"
                size="small"
                fullWidth
                value={values.name}
                onChange={(e) => setFieldValue("name", e.target.value)}
                error={touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                className="my-2"
              />

              {/* Alt aksiyonlar */}
              <h6>Alt Aksiyonlar</h6>
              <Autocomplete
                multiple
                options={subActions}
                getOptionLabel={(option) => option.name}
                value={values.selectedSubActions}
                onChange={(e, newValue) =>
                  setFieldValue("selectedSubActions", newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Alt Aksiyon Seç"
                    size="small"
                    error={
                      touched.selectedSubActions &&
                      !!errors.selectedSubActions
                    }
                    helperText={
                      touched.selectedSubActions && errors.selectedSubActions
                    }
                  />
                )}
                className="my-2"
              />
            </Modal.Body>

            {/* Modal Footer */}
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                İptal
              </button>
              <button type="submit" className="btn btn-primary">
                Kaydet
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export default ActionAddModal;
